const getUser = state => state.authentication.user;

export default getUser;